import type {FC} from 'react';
import {Box, Fab, Icon, IconNames} from '@wellstone-solutions/web';
import {useTheme} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';

interface ActionButtonProps {
  iconName?: string;
  onClick: () => void;
  label: string;
  testId?: string;
}

export const ActionButton: FC<ActionButtonProps> = ({
  iconName = IconNames.Plus,
  onClick,
  label,
  testId,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box>
      {isMobile ? (
        <Fab
          size="small"
          aria-label={label}
          color="primary"
          onClick={onClick}
          data-testid={testId}>
          <Icon
            name={iconName}
            color={theme.palette.onPrimary}
            strokeWidth={2}
          />
        </Fab>
      ) : (
        <Fab
          size="medium"
          variant="extended"
          color="primary"
          onClick={onClick}
          data-testid={testId}
          sx={{whiteSpace: 'nowrap', paddingRight: 3}}>
          <Icon
            name={iconName}
            color={theme.palette.onPrimary}
            style={{marginRight: 8}}
            strokeWidth={2}
            size={20}
          />
          {label}
        </Fab>
      )}
    </Box>
  );
};
